import InternalOrderDestinationFields from './InternalOrderDestinationFields';
import { useMemo } from 'react';
import { Box, Grid } from '@mui/material';
import {
  CustomAutoComplete,
  CustomTextArea,
  CustomTextField,
  renderTwoLineOption,
} from '../../../common/components';
import { AUTOCOMPLETE_LISTBOX_PROPS } from '../../../common/styles';
import InternalOrderMaterialsSection from './InternalOrderMaterialsSection';
import { INTERNAL_ORDER_FORM_TEXTS as TEXTS } from '../constants/internalOrdersConstants';
import { toWarehouseOptions } from '../../utils/toWarehouseOptions';

/**
 * Datos de cabecera y materiales del alta de un pedido técnico.
 * @param {Object} props
 * @returns {JSX.Element}
 */
const InternalOrderFormSection = ({
  groupOptions,
  groupSearch,
  setGroupSearch,
  changeGroups,
  operationalDestinations = [],
  selectedOrder,
  onInputChange,
  onSelectChange,
  isMobile,
  warehouses = [],
  warehousesLoading = false,
  projects = [],
  projectsLoading = false,
  searchEnabled = true,
  onAddMaterial,
  onUpdateMaterialQuantity,
  onRemoveMaterial,
}) => {
  const warehouseOptions = useMemo(() => toWarehouseOptions(warehouses), [warehouses]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <InternalOrderDestinationFields
        selectedOrder={selectedOrder}
        destinations={operationalDestinations}
        projects={projects}
        onChange={onSelectChange}
      />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <CustomAutoComplete
            label={TEXTS.warehouse}
            name="uuid_destination_warehouse"
            value={selectedOrder.uuid_destination_warehouse || ''}
            options={warehouseOptions}
            renderOption={renderTwoLineOption}
            inputPlaceholder={warehousesLoading ? TEXTS.loadingWarehouses : TEXTS.searchWarehouse}
            loading={warehousesLoading}
            disabled={warehousesLoading}
            ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
            onChange={onSelectChange}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <CustomTextField
            label={TEXTS.neededDate}
            name="needed_date"
            type="date"
            value={selectedOrder.needed_date || ''}
            onChange={onInputChange}
            required
            shrinkLabel
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <CustomTextField
            label={TEXTS.neededTime}
            name="needed_time"
            type="time"
            value={selectedOrder.needed_time || ''}
            onChange={onInputChange}
            required
            shrinkLabel
          />
        </Grid>

        <Grid item xs={12}>
          <CustomTextArea
            label={TEXTS.observations}
            name="observations"
            value={selectedOrder.observations || ''}
            onChange={onInputChange}
            minRows={isMobile ? 2 : 3}
          />
        </Grid>
      </Grid>

      <InternalOrderMaterialsSection
        groupOptions={groupOptions}
        groupSearch={groupSearch}
        setGroupSearch={setGroupSearch}
        changeGroups={changeGroups}
        materials={selectedOrder.materials || []}
        searchEnabled={searchEnabled}
        onAddMaterial={onAddMaterial}
        onUpdateMaterialQuantity={onUpdateMaterialQuantity}
        onRemoveMaterial={onRemoveMaterial}
      />
    </Box>
  );
};

export default InternalOrderFormSection;
